import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Grid, Button, IconButton } from "@material-ui/core";
import PageBanner from "./components/pageBanner";
import Panel from "./components/whitePanel";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import httpRequest from "../HttpService";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { getStatusString, getLocationString } from "../newOrder/components/helperFunctions/index.js";
import MapboxPanel from "./components/MapboxPanel/index";
import logo from "../directitgroupcourier.jpg";
import moment from "moment";
import Carousel from "./components/carouselPanel";
import PrintIcon from "@material-ui/icons/Print";
import CopyIcon from "@material-ui/icons/FileCopy";
import DownloadIcon from "@material-ui/icons/SaveAlt";
import ImageViewer from "./components/imageViewer.js";
// import FileUploadIcon from '@mui/icons-material/FileUpload';
// import {Dialog,DialogTitle,DialogContent,DialogActions,} from "@material-ui/core";

import { saveAs } from "file-saver";
import copy from "copy-to-clipboard";
import Copyright from "../Copyright";
import {
    JSPrintManager,
    WSStatus,
    ClientPrintJob,
    InstalledPrinter,
    ClientScanJob,
    ScannerImageFormatOutput,
} from "jsprintmanager";
// import ReactToPrint from "react-to-print";
import PrintPanel from "../newOrder/components/printPanel";
import "./orderDetail.css";
import Gallery from "../newOrder/components/gallery";
import ReactPanZoom from "../newOrder/components/ImagePan";
import Alert from "./components/Alert.js";
import OrderReceiptPanel from "./components/OrderReceiptPanel.js";
//  http://localhost:3001/trackNo/TR7991015074139
import { useNavigate } from "react-router-dom";
import { Box, Chip, CircularProgress, Container, Divider, Stack, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";

export default function TrackingOrderDetail(props) {
    const navigate = useNavigate();
    const { trackingNumber: trackingNumberParam } = useParams();
    const { trackingAccount } = useParams();
    const { trackingReference } = useParams();
    // Allows embedding this page (e.g. a master-detail split view) without a
    // /trackNo/:trackingNumber route match - falls back to the route param.
    const trackingNumber = props.trackingNumberOverride || trackingNumberParam;
    const componentRef = useRef();
    const receiptPrintRef = useRef();

    const [photoArray, setPhotoArray] = useState([]);
    const [showDeliveryDetails, setShowDeliveryDetails] = useState(false);
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [order, setOrder] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const [openAddFilesBox, setOpenAddFilesBox] = useState(false);
    const [selectPrinter, setSelectPrinter] = useState(null);
    const [printsList, setPrintsList] = useState([]);
    const [isPrint, setIsPrint] = useState(false);
    const [intervalId, setIntervalId] = useState(null);
    const [isUploadFile, setIsUploadFile] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [isPrintReceipt, setIsPrintReceipt] = useState(false);
    const isMobile = useMediaQuery("(max-width:768px)");

    useEffect(() => {
        try {
            let search =
                props.trakingType === "trackingNumber"
                    ? { trackingNumber: trackingNumber }
                    : {
                          cust_ref: trackingReference,
                          trackAccount: trackingAccount,
                      };

            // httpRequest.orderSearch("",search).then((body) =>{
            //     console.log("trackingNumber-" +JSON.stringify(body.data));
            //     if(body.data.length>0){
            //         let order = body.data[0];
            //         initOrderDetail( order.ACCOUNT,order.jobID);
            //     }
            //     else
            //         window.location.href='/tracking';
            // });

            initTripDetail();

            try {
                JSPrintManager.auto_reconnect = true;
                JSPrintManager.start();
                JSPrintManager.WS.onStatusChanged = () => {
                    if (JSPrintManager.websocket_status === WSStatus.Open) {
                        JSPrintManager.getPrintersInfo().then(async (printersList) => {
                            let printers = printersList.map((item, i) => {
                                return { value: i, label: item.name };
                            });
                            setPrintsList(printers);
                            console.log("tracking Printer list :" + JSON.stringify(printers));
                            var defaultPrinter = printers.find(function (obj) {
                                return obj.label.includes("ZPL");
                            });
                            console.log("Default Printer :" + JSON.stringify(defaultPrinter));
                            if (defaultPrinter !== undefined) {
                                var index = printers.findIndex((x) => x.label === defaultPrinter.label);
                                setSelectPrinter(printers[index].label);
                            }
                            console.log("Tracking selectPrinter :" + selectPrinter);
                        });
                    }
                };
            } catch (e) {
                console.log("JSPrintManager--- exception", e);
            }
        } catch (e) {
            console.log("exception", e);
        }
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, []);

    const initTripDetail = () => {
        httpRequest.getTripInfo(trackingNumber).then((response) => {
            console.log("getOrder--" + JSON.stringify(response.data));
            const orders = response.data?.order;
            if (!Array.isArray(orders) || orders[0] === undefined || orders[0] === null) {
                if (props.embedded) {
                    setNotFound(true);
                } else {
                    navigate(`/notFound`);
                }
                return;
            }
            let _order = orders[0];
            if (_order.dtDelivered) _order.dtDelivered_display = _order.dtDelivered.substring(0, 19).replace("T", " ");
            if (_order.dtCallIn) _order.dtCallIn_display = _order.dtCallIn.substring(0, 19).replace("T", " ");
            if (_order.dtDCT) _order.dtDCT_display = _order.dtDCT.substring(0, 19).replace("T", " ");
            setOrder(_order);
            getOrderTrack(_order.jobID);
            setPhotoArray(processPhotos(response.data.photos));
            /*
        if (_order.Status < 8) {
          const newIntervalId = setInterval(() => {
            getPhotos(_order.jobID);          
            httpRequest.getTripInfo(trackingNumber).then((response) => {
              var _order = response.data[0];
              if (_order.dtDelivered)
                _order.dtDelivered_display = _order.dtDelivered.substring(0, 19).replace("T", " ");
              if (_order.dtCallIn)
                _order.dtCallIn_display = _order.dtCallIn.substring(0, 19).replace("T", " ");
              if (_order.dtDCT)
                _order.dtDCT_display = _order.dtDCT.substring(0, 19).replace("T", " ");
              setOrder(_order);
              getOrderTrack(_order.jobID);

              if (_order.Status >= 8) clearInterval(intervalId);
            });
          }, 300000);
          setIntervalId(newIntervalId);       
        }
        */
        });
    };

    const setUploadFileFlag = () => {
        setIsUploadFile(true);
    };

    const isDelivered = order?.Status >= 8;
    const statusColor = isDelivered ? "success.main" : "primary.main";
    const companyLogo = order?.brandLogoURL;

    // Photos now arrive embedded in the tripInfo response (same AzureImages
    // query web.get_photoURL used to run separately for this same audience) -
    // this just applies the same display fields it always did.
    const processPhotos = (rawPhotos) => {
        if (!Array.isArray(rawPhotos)) return [];
        return rawPhotos.map((value, i) => {
            value.savedTimeUTC = moment(value.savedTimeUTC).format("YY-MM-DD HH:mm");
            value.id = i;
            value.imageType =
                value.url.endsWith("png") || value.url.endsWith("jpg") || value.url.endsWith("bmp")
                    ? "image"
                    : "file";
            value.fileType =
                value.url.endsWith("png") || value.url.endsWith("jpg") || value.url.endsWith("bmp")
                    ? "image"
                    : value.url.substring(value.url.length - 3);
            value.fileExt = value.url.substring(value.url.length - 3);
            if (
                value.fileExt === "pdf" ||
                value.fileExt === "doc" ||
                value.fileExt === "docx" ||
                value.fileExt === "xls" ||
                value.fileExt === "xlsx" ||
                value.fileExt === "csv"
            ) {
                var file_url = `https://drive.google.com/viewerng/viewer?embedded=true&url=${value.url}#toolbar=0&scrollbar=0`;
                value.file_url = file_url;
            }
            return value;
        });
    };

    const getOrderTrack = (orderID) => {
        httpRequest.getOrderTrack(orderID).then((response) => {
            //console.log("getOrderTrack--" + JSON.stringify(response.data));
            if (!Array.isArray(response.data)) return;
            var tempTrackList = response.data.map((option, index) => {
                return {
                    ...option,
                    id: index,
                };
            });
            setSteps(tempTrackList);
        }).catch((err) => {
            console.error("getOrderTrack failed", err);
        });
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const renderStepContentText = (label) => {
        return (
            <div>
                <Typography>{label.bigText}</Typography>
                <Typography variant="caption">
                    {label.smallText +
                        moment(label.timestamp_utc).format("MM-DD") +
                        " @ " +
                        moment(label.timestamp_utc).format("LT")}
                </Typography>
                {label.img_url && (
                    <span>
                        <a
                            onClick={() => {
                                window.open(label.img_http_link, "_blank");
                            }}
                        >
                            {label.img_text}
                        </a>
                        <div>
                            <img
                                style={{ width: "80px", height: "60px" }}
                                src={label.img_url}
                                onClick={() => {
                                    window.open(label.img_http_link, "_blank");
                                }}
                            />
                        </div>
                    </span>
                )}
            </div>
        );
    };

    const renderFromAddress = () => {
        let suite = order?.sSuite ? order?.sSuite + ", " : "";
        return `${suite} ${order?.sAddress}  ${order?.sQuad}, ${order?.sCity}, ${order?.sProv}, ${order?.sPostal}, ${order?.sCountry}`;
    };

    const renderToAddress = () => {
        let suite = order?.cSuite ? order?.cSuite + ", " : "";
        return `${suite} ${order?.cAddress}  ${order?.cQuad}, ${order?.cCity}, ${order?.cProv}, ${order?.cPostal}, ${order?.cCountry}`;
    };

    const handleClick = () => {
        setShowDeliveryDetails(!showDeliveryDetails);
    };

    const renderDeliveryDetails = () => {
        return (
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <h6>LOCATION</h6>
                    <p>{getLocationString(order?.location)}</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h6>BILLING REFERENCE #</h6>
                    <p> {order?.CUST_REF} </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h6>CALLER</h6>
                    <p> {order?.CALLER} </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h6>CALL IN</h6>
                    <p> {order?.dtCallIn_display + " " + order?.timezone}</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h6>DUE BY</h6>
                    <p> {order?.dtDCT_display + " " + order?.timezone} </p>
                </Grid>
                <Grid item md={6}>
                    <h6>Status</h6>
                    <p> {getStatusString(order?.Status)} </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h6>PROOF OF DELIVERY</h6>
                    <p> {order?.PROOF_DEL} </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h6>ACCESSORIES</h6>
                    <p> {order?.Accessories} </p>
                </Grid>
            </Grid>
        );
    };

    // const printClick = () => {
    //     console.log("selectPrinter :" + selectPrinter);
    //     if (selectPrinter && selectPrinter.includes("ZPL")) {
    //       if (JSPrintManager.websocket_status === WSStatus.Open) {
    //         httpRequest.getLabelString(order.jobID).then(async (body) => {
    //           console.log("getZPLLabel return-" + JSON.stringify(body.data));
    //           var zplLabel = body.data;
    //           if(zplLabel.ZPLString !== null){
    //             var cpj = new ClientPrintJob();
    //             cpj.clientPrinter = new InstalledPrinter(selectPrinter);
    //             cpj.printerCommands = zplLabel.ZPLString;
    //             cpj.sendToClient();
    //           }
    //           else {
    //             setOpenSnack(true);
    //             setAlertMsg("ZPL string is null!");
    //             setIsPrint(true);
    //           }
    //         });
    //       }
    //     } else {
    //         setIsPrint(true);
    //     }
    // };

    const doPrintReceipt = useReactToPrint({
        content: () => receiptPrintRef.current,
        pageStyle: `
            @page { size: A4 portrait; margin: 12mm; }
            @media print {
                * { box-sizing: border-box; }
                body { width: 210mm; }
                img { max-width: 100% !important; height: auto !important; }
            }
        `,
        onAfterPrint: () => {
            setIsPrintReceipt(false);
        },
    });

    useEffect(() => {
        if (!isPrintReceipt) return;
        const t = setTimeout(() => {
            doPrintReceipt();
        }, 500);
        return () => clearTimeout(t);
    }, [isPrintReceipt]);

    // const cancelPrint = () => { setIsPrint(false); };
    // const addFilesClick = () => { setOpenAddFilesBox(true) };
    // const addFilesClose = () => { setOpenAddFilesBox(false) };

    //   const handleInputChange = (event) => {
    //     const { name, value } = event.target;
    //     this.setState({ [name]: value });
    //   };

    const StatItem = ({ label, value }) => (
        <Box sx={{ flex: 1, minWidth: 0, px: { xs: 0, sm: 1 } }}>
            <Typography
                variant="caption"
                sx={{
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    color: "text.secondary",
                    fontWeight: 600,
                    mb: 0.5,
                }}
            >
                {label}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
                {value || <span style={{ color: "#bbb" }}>—</span>}
            </Typography>
        </Box>
    );

    const DetailField = ({ label, value }) => (
        <Grid item xs={4}>
            <Typography
                variant="caption"
                sx={{
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.7px",
                    color: "text.disabled",
                    fontWeight: 700,
                    fontSize: "0.62rem",
                }}
            >
                {label}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.primary", fontWeight: 500, lineHeight: 1.4 }}>
                {value || <span style={{ color: "#ccc" }}>—</span>}
            </Typography>
        </Grid>
    );

    return (
        <Box className="NewOrder">
            {!props.embedded && <PageBanner title="PARCEL STATUS" subheading={"#" + order?.jobID} />}
            <Container maxWidth="lg" disableGutters={props.embedded}>
                <div id="pageContent" style={{ marginTop: props.embedded ? 0 : "-48px" }}>
                    {!isPrint && !order && !notFound && (
                        <Stack alignItems="center" justifyContent="center" sx={{ py: 10 }}>
                            <CircularProgress size={32} />
                        </Stack>
                    )}
                    {!isPrint && notFound && (
                        <Stack alignItems="center" spacing={1} sx={{ py: 10, textAlign: "center" }}>
                            <SearchOffIcon sx={{ fontSize: 40, color: "text.disabled" }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                No delivery found
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                We couldn't find a shipment matching "{trackingNumber}". Double check the tracking
                                number and try again.
                            </Typography>
                        </Stack>
                    )}
                    {!isPrint && order && (
                        <Stack spacing={2} sx={{ pb: 4 }}>
                            <Grid item xs={12}>
                                <Panel>
                                    <Grid container spacing={3} alignItems="center">
                                        <Grid item xs={12} lg={3} xl={3}>
                                            <Stack
                                                spacing={1.5}
                                                sx={{
                                                    borderRight: { lg: "1px solid" },
                                                    borderBottom: { xs: "1px solid", lg: "none" },
                                                    borderColor: { xs: "divider", lg: "divider" },
                                                    pr: { lg: 3 },
                                                    pb: { xs: 2, lg: 0 },
                                                }}
                                            >
                                                <Box>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            display: "block",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            color: "text.secondary",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        Status
                                                    </Typography>
                                                    <Typography
                                                        variant="h5"
                                                        sx={{
                                                            fontWeight: 700,
                                                            color: statusColor,
                                                            mt: 0.5,
                                                        }}
                                                    >
                                                        {getStatusString(order.Status) || "—"}
                                                    </Typography>
                                                </Box>
                                                {order.TrackNumber && (
                                                    <Box>
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                display: "block",
                                                                textTransform: "uppercase",
                                                                letterSpacing: "0.5px",
                                                                color: "text.secondary",
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            Tracking Number
                                                        </Typography>
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={0.5}
                                                            sx={{ mt: 0.25 }}
                                                        >
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    fontFamily: "monospace",
                                                                    letterSpacing: "0.5px",
                                                                }}
                                                            >
                                                                {order.TrackNumber}
                                                            </Typography>
                                                            <IconButton
                                                                size="small"
                                                                aria-label="copy tracking link"
                                                                onClick={() => {
                                                                    copy(
                                                                        "https://tracking.directx.ca/trackNo/" +
                                                                            order.TrackNumber
                                                                    );
                                                                }}
                                                            >
                                                                <CopyIcon fontSize="small" color="primary" />
                                                            </IconButton>
                                                        </Stack>
                                                    </Box>
                                                )}
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} lg={9} xl={9}>
                                            <Stepper
                                                activeStep={activeStep}
                                                alternativeLabel={!isMobile}
                                                orientation={isMobile ? "vertical" : "horizontal"}
                                            >
                                                {steps.map((label) => (
                                                    <Step key={label.bigText} completed={label.filled}>
                                                        <StepLabel>{renderStepContentText(label)}</StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                        </Grid>
                                    </Grid>
                                </Panel>
                                {/* === ROUTE === */}
                                <Panel>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="flex-start"
                                        sx={{ mb: 2 }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {companyLogo && (
                                                <img
                                                    src={companyLogo}
                                                    alt="Company Logo"
                                                    style={{ height: 36, display: "block" }}
                                                />
                                            )}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            startIcon={<PrintIcon />}
                                            onClick={() => {
                                                setIsPrintReceipt(true);
                                            }}
                                        >
                                            Print Receipt
                                        </Button>
                                    </Stack>

                                    <Grid container spacing={2} alignItems="stretch">
                                        <Grid item xs={12} md>
                                            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                                <LocationOnIcon
                                                    sx={{ color: "text.secondary", mt: 0.25 }}
                                                    fontSize="small"
                                                />
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            display: "block",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            color: "text.secondary",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        From
                                                    </Typography>
                                                    <Typography
                                                        variant="subtitle1"
                                                        sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
                                                    >
                                                        {order.sCompanyName || "—"}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {renderFromAddress()}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md="auto"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "text.disabled",
                                            }}
                                        >
                                            <ArrowForwardIcon sx={{ display: { xs: "none", md: "block" } }} />
                                        </Grid>
                                        <Grid item xs={12} md>
                                            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                                <LocationOnIcon
                                                    sx={{ color: "primary.main", mt: 0.25 }}
                                                    fontSize="small"
                                                />
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            display: "block",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            color: "text.secondary",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        To
                                                    </Typography>
                                                    <Typography
                                                        variant="subtitle1"
                                                        sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
                                                    >
                                                        {order.cCompanyName || "—"}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {renderToAddress()}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </Grid>
                                    </Grid>

                                    <Divider sx={{ my: 2.5 }} />

                                    {/* Package stats */}
                                    <Stack
                                        direction={{ xs: "column", sm: "row" }}
                                        spacing={{ xs: 1.5, sm: 0 }}
                                        divider={
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{ display: { xs: "none", sm: "block" } }}
                                            />
                                        }
                                        sx={{ mb: order.DEL_INST ? 2 : 0 }}
                                    >
                                        <StatItem label="Pieces" value={order.PIECES} />
                                        <StatItem label="Weight" value={order.WEIGHT} />
                                        {(order.DimsString || order.dimsString) && (
                                            <StatItem label="Dims" value={order.DimsString || order.dimsString} />
                                        )}
                                        <StatItem label="Service" value={order.serviceText} />
                                    </Stack>

                                    {order.DEL_INST && (
                                        <Box
                                            sx={{
                                                bgcolor: "rgba(51, 122, 183, 0.06)",
                                                borderLeft: "3px solid",
                                                borderColor: "primary.main",
                                                p: 1.5,
                                                borderRadius: "0 4px 4px 0",
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: "block",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.5px",
                                                    color: "primary.main",
                                                    fontWeight: 600,
                                                    mb: 0.25,
                                                }}
                                            >
                                                Special Instructions
                                            </Typography>
                                            <Typography variant="body2">{order.DEL_INST}</Typography>
                                        </Box>
                                    )}
                                </Panel>

                                {/* === PROOF OF DELIVERY === */}
                                {isDelivered && (
                                    <Panel>
                                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.5px",
                                                    color: "text.secondary",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                Proof of Delivery
                                            </Typography>
                                            {getStatusString(order.Status) && (
                                                <Chip
                                                    label={getStatusString(order.Status)}
                                                    size="small"
                                                    color="success"
                                                    variant="outlined"
                                                    sx={{ height: 20, fontSize: "0.7rem" }}
                                                />
                                            )}
                                        </Stack>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={5}>
                                                {order.signatureURL ? (
                                                    <Box
                                                        sx={{
                                                            p: 2,
                                                            border: "1px solid",
                                                            borderColor: "divider",
                                                            borderRadius: 1,
                                                            bgcolor: "#fafafa",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <img
                                                            src={order.signatureURL}
                                                            alt="Customer Signature"
                                                            style={{
                                                                display: "block",
                                                                width: "100%",
                                                                maxWidth: 320,
                                                                margin: "0 auto",
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                            sx={{ display: "block", mt: 1 }}
                                                        >
                                                            Signature on file
                                                        </Typography>
                                                    </Box>
                                                ) : (
                                                    <Box
                                                        sx={{
                                                            p: 2,
                                                            border: "1px dashed",
                                                            borderColor: "divider",
                                                            borderRadius: 1,
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="body2" color="text.secondary">
                                                            No signature captured
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Grid>
                                            <Grid
                                                container
                                                item
                                                xs={12}
                                                md={7}
                                                display="flex"
                                                justifyContent="flex-start"
                                            >
                                                <DetailField label="Signed By" value={order.PROOF_DEL} />
                                                <DetailField
                                                    label="Delivered"
                                                    value={
                                                        order.dtDelivered_display
                                                            ? order.dtDelivered_display + " " + (order.timezone || "")
                                                            : ""
                                                    }
                                                />
                                                <DetailField
                                                    label="Delivered To"
                                                    value={getLocationString(order.location)}
                                                />

                                                <DetailField label="Caller" value={order.CALLER} />
                                                <DetailField
                                                    label="Call In"
                                                    value={order?.dtCallIn_display + " " + order?.timezone}
                                                />
                                                <DetailField
                                                    label="Due By"
                                                    value={order?.dtDCT_display + " " + order?.timezone}
                                                />
                                                <DetailField label="Billing Reference" value={order.CUST_REF} />
                                                <DetailField label="Accessories" value={order.Accessories} />
                                            </Grid>
                                        </Grid>
                                    </Panel>
                                )}

                                <Grid container>
                                    <Grid item md={7} xs={12}>
                                        <Panel>
                                            <h6>LIVE TRACKING</h6>
                                            <Grid container>
                                                {order?.jobID && (
                                                    <MapboxPanel
                                                        orderID={order.jobID}
                                                        order={order}
                                                        photoList={photoArray}
                                                    />
                                                )}
                                            </Grid>
                                        </Panel>
                                    </Grid>
                                    <Grid item md={5} xs={12}>
                                        <Panel>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <h6>IMAGES</h6>
                                                </Grid>
                                                <Grid item xs={6}></Grid>
                                            </Grid>
                                            <Carousel
                                                show={photoArray?.length !== 0 ? true : false}
                                                numOfImages={photoArray?.length}
                                            >
                                                {photoArray.map((image, i) => (
                                                    <div
                                                        key={i}
                                                        style={{
                                                            justifyContent: "center",
                                                            height: "50%",
                                                            verticalAlign: "middle",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        {image.imageType === "image" ? (
                                                            // <ReactPanZoom src={image.url} />
                                                            <ImageViewer src={image.url} />
                                                        ) : (
                                                            <IconButton
                                                                color="primary"
                                                                onClick={() => {
                                                                    console.log("onClick");
                                                                    saveAs(image.url, `${order.jobID}-${i}`); // Put your image url here.
                                                                }}
                                                            >
                                                                <DownloadIcon />
                                                                <iframe
                                                                    src={image.file_url}
                                                                    height="420px"
                                                                    width="100%"
                                                                ></iframe>
                                                            </IconButton>
                                                        )}
                                                    </div>
                                                ))}
                                            </Carousel>
                                        </Panel>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Stack>
                    )}
                    {/* {isPrint && (
              <Panel>
                <Button variant="contained"  color="primary"   onClick={() => {setIsPrint(false)}} style={{ float: "right", margin: "2px" }}>
                  Cancel
                </Button> 
                <Button variant="contained"  color="primary"  onClick={handlePrint}> Print</Button>
                <PrintPanel id={order.jobID} account = {order.ACCOUNT} ref={componentRef}/>
              </Panel>
            )}   */}
                    {isPrintReceipt && (
                        <Panel>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setIsPrintReceipt(false);
                                }}
                                style={{ float: "right", margin: "2px" }}
                            >
                                Back
                            </Button>
                            <OrderReceiptPanel order={order} ref={receiptPrintRef} />
                        </Panel>
                    )}
                </div>
                {/* <Dialog fullWidth={true} maxWidth="xl" className="addFilesDialog" open={openAddFilesBox} onClose={addFilesClose}>
            <DialogTitle>Add Files</DialogTitle>
            <DialogContent>
                <Gallery  jobId={order.jobID}   setUploadFileFlag={setUploadFileFlag}/>
            </DialogContent>
            <DialogActions>
              <Button onClick={addFilesClose}>Cancel</Button>
            </DialogActions>
          </Dialog>  */}
                <Alert
                    openSnack={openSnack}
                    alertMsg={alertMsg}
                    snackClose={() => {
                        setOpenSnack(false);
                    }}
                />
                {!props.embedded && (
                    <footer>
                        <Copyright />
                    </footer>
                )}
            </Container>
        </Box>
    );
}
